import readlangClient from "readlangClient";
import * as experimentUtils from "shared/experimentUtils";

/**
 * When a user is treated, we cache the condition so that we don't have to compute the condition
 * again, and so that we know not to call /treat again.
 *
 */
const treatedConditionCache: { [experiment: string]: string } = {};

/**
 * Returns the condition of the experiment and, if this is the first call for the given experiment
 * during this session, initiates a server request to treat the user for the experiment.
 */
export const getConditionAndTreat = (
  experiment: experimentUtils.ExperimentName
): string => {
  const userID = window.READLANG.userID;
  const cachedCondition = treatedConditionCache[experiment];
  if (cachedCondition) {
    return cachedCondition;
  }

  // If there is no cached condition, compute it
  const { condition, override } = experimentUtils.getCondition(
    userID,
    experiment
  );

  if (override) {
    console.log("Using experiment override: ", experiment, condition);
    // If there is an override, use it and don't treat the user
    return condition;
  }

  // Treat the user in this experiment. They may have been treated before in a previous session,
  // but in this case the backend will ignore the request.
  readlangClient.request(
    "POST",
    "/api/experiment/treat",
    {
      experiment,
      condition, // This is used as a sanity check on the backend
    },
    () => {
      // User treated
    },
    undefined
  );

  return condition;
};
